<template>
  <div class="iain-image-domain" :style="{ width, height}">
    <van-image v-if="!visible" fit="cover" v-bind="vanImageProps" />
    <van-image v-else fit="cover" :src="targetImagePath" v-bind="vanImageProps" @click="click" />
  </div>
</template>

<script>
import { validURL } from '@/utils/validate'

import { getTargetUnit, checkStatic } from '../utils'

export default {
  name: 'iain-image-domain',
  props: {
    src: {
      type: String,
      default: ''
    },

    w: {
      type: [String, Number],
      default: '100%'
    },

    h: {
      type: [String, Number],
      default: '100%'
    },

    r: {
      type: [String, Number],
      default: 8
    },

    round: {
      type: Boolean,
      default: false
    },

    preview: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      error: false
    }
  },
  watch: {
    src() {
      this.error = false
    }
  },
  computed: {
    visible() {
      // 避免 :src="''" => 'true'
      if (!this.src || this.src === 'true') return false
      if (!this.targetImagePath) return false
      if (this.error) return false
      return true
    },

    targetImagePath() {
      const path = this.src

      if (!path) return ''

      // 静态资源
      if (checkStatic(path)) return path
      // 网络资源
      if (validURL(path)) return path
      // 项目资源
      return this.$FILE_PATH + path
    },

    width() {
      return getTargetUnit(this.w)
    },

    height() {
      return getTargetUnit(this.h)
    },

    vanImageProps() {
      const { round, r } = this

      return {
        width: '100%',
        height: '100%',
        round,
        radius: round ? null : getTargetUnit(r)
      }
    }
  },
  methods: {
    click() {
      if (!this.preview) return
      this.$ImagePreview([this.targetImagePath])
    }
  }
}
</script>

<style lang="scss" scoped>
.iain-image-domain {
  display: inline-block;
  vertical-align: middle;
  overflow: hidden;
}
</style>
